import { TemplateVisibility } from '@heidi/schema/ml-scribe';
import type { TemplateResponse } from '../contracts';

/**
 * Template list precedence (D2.7, ARCFE-1046), moved VERBATIM from
 * `src/helpers/sortTemplates.ts`, which had exactly one importer — the document
 * template list that moved with it.
 *
 * Note the name collision this does NOT touch:
 * `src/components/ui/choose-note-structure-modal/…/utils.ts` also exports a
 * `sortTemplates`, but it is a different function with a different signature
 * (`(templates, sortFilter)` rather than a comparator) and stays where it is.
 *
 * `TemplateResponse` resolves to the same declaration it always did —
 * `src/types/index.ts` re-exports it from this package's `/contracts` door — so
 * the comparator is not silently rebound to a different shape. That check is
 * the `TemplateSortBy` lesson from D1.1, where identical body text bound a
 * different resolved type and only tsc noticed.
 */
export const sortTemplates = (a: TemplateResponse, b: TemplateResponse) => {
  if (
    a.template_visibility === TemplateVisibility.Team &&
    b.template_visibility !== TemplateVisibility.Team
  ) {
    return -1;
  }
  if (a.is_favorite === b.is_favorite) {
    if (b.last_used && a.last_used) {
      return new Date(b.last_used).getTime() - new Date(a.last_used).getTime();
    }
  }
  return a.is_favorite ? -1 : 1;
};
